<p8-layout-settings-header [titlePath]="['Gestion des entités']"></p8-layout-settings-header>
<mat-tab-group>
  <mat-tab>
    <ng-template mat-tab-label >
      <span class="mat-tab-label" (click)="setChoice(entiteTypeEnum.dir)">Services</span>
    </ng-template>
    <ng-container *ngIf="entityChoice === entiteTypeEnum.dir">
      <app-common-entites [application]="constantes.application"
                          [entityType]="entiteTypeEnum.dir"
                          [levelMaxExpand]="constantes.ADM_LEVEL_MAX_EXPAND"
                          [customLabel]="">
      </app-common-entites>
    </ng-container>
  </mat-tab>

  <mat-tab>
    <ng-template mat-tab-label >
      <span class="mat-tab-label" (click)="setChoice(entiteTypeEnum.cmp)">Composantes</span>
    </ng-template>
    <ng-container *ngIf="entityChoice === entiteTypeEnum.cmp">
      <app-common-entites [application]="constantes.application"
                          [entityType]="entiteTypeEnum.cmp"
                          [levelMaxExpand]="constantes.CMP_LEVEL_MAX_EXPAND"
                          [customLabel]="">
      </app-common-entites>
    </ng-container>
  </mat-tab>
</mat-tab-group>
